import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  SaveButton,
  FormDashboardLabel as Label,
  FormRow,
  FormDashboardInputPassword as Input,
} from '../../../components'
import { changePassword } from '../../../features/account/slice'
import { useInternationalization } from '../../../features/i18n'
import { errorHandler, formUpdater } from '../../../utils'
import auth from '../../../utils/auth'

const label = {
  success: {
    en: "Password sucessfully changed!",
    id: "Kata sandi berhasil diubah!"
  },
  confirm: {
    en: 'You will be logged out after the password successfully changed. Are you sure want to change password now?',
    id: 'Anda akan keluar setelah kata sandi berhasil diubah. Apakah Anda yakin akan mengubah kata sandi sekarang? '
  },
  error: {
    en: 'Incorrect password repetition. Make sure "New Password" and "Repeat Password" have the exact same content.',
    id: 'Pengulangan kata sandi salah. Pastikan "Kata Sandi Baru" dan "Ulangi Kata Sandi" memiliki isi yang sama persis.'
  }
}

const FormPassword = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [form, setForm] = React.useState({})
  const [requesting, setRequesting] = React.useState(false)
  const { translate, language } = useInternationalization()

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);

    const {
      newPassword,
      confirmNewPassword
    } = form

    if(newPassword === confirmNewPassword){
      let c = window.confirm(label.confirm[language.name])

      if(c){
        setRequesting(true);
        dispatch(changePassword(form))
          .then((res) => {
            console.log(res);
            if(!res.payload){
              const msg = errorHandler(res.error)
              toast.error(msg)
            } else {
              toast.success(label.success[language.name]);
              auth().logout()
              history.replace('/login')
            }
          })
          .catch(err => {
            const msg = errorHandler(err)
            toast.error(msg)
          })
          .finally(() => {
            setRequesting(false);
          });
      }
    } else {
      toast.error(label.error[language.name])
    }
  }

  const updateForm = (e) => formUpdater(e, form, setForm)

  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <Label>{translate('AUTH', 'password_current')}</Label>
        <Input
          required
          className="w-full"
          name="oldPassword"
          onChange={updateForm}
        />
      </FormRow>
      <FormRow>
        <Label>{translate('AUTH', 'password_new')}</Label>
        <Input
          required
          className="w-full"
          name="newPassword"
          onChange={updateForm}
        />
      </FormRow>
      <FormRow last>
        <Label>{translate('AUTH', 'password_repeat')}</Label>
        <Input
          required
          className="w-full"
          name="confirmNewPassword"
          onChange={updateForm}
        />
      </FormRow>
      <SaveButton disabled={requesting} isLoading={requesting}/>
    </form>
  )
}

export { FormPassword }
